<template>
    <div :class="{ 'kgr-grid kgr-grid--columnGutters kgr-grid--inlineBlock': inline }">
        <label
            v-for="(val, key) in options"
            :key="val"
            class="kgr-radio"
            :class="{ 'is-disabled': disabled, 'kgr-grid__cell': inline, 'kgr-row kgr-row--extraSmallMargin kgr-row--noneIfLastChild': !inline, 'kgr-radio--small': small }"
        >
            <input
                type="radio"
                class="kgr-radio__control"
                :class="{ 'kgr-radio--inline': inline }"
                :name="name"
                :value="val"
                :checked="val == value"
                :disabled="disabled"
                @change="(ev) => onChange(val)"
            />
            <span
                class="kgr-radio__label"
                :class="{ 'kgr-radio--inline': inline }"
            >{{ $t(key) }}</span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        name: '',
        value: '',
        options: '',
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        small: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    methods: {
        onChange(val) {
            this.$emit('input', val);
            this.$nextTick(() => {
                this.$emit('post-input', val);
            });
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
